"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CfgPayoutEditor = /** @class */ (function (_super) {
    __extends(CfgPayoutEditor, _super);
    function CfgPayoutEditor(props) {
        return _super.call(this, props) || this;
    }
    CfgPayoutEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    css_class: _item.css_classname,
                    is_deprecated: _item.is_deprecated,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    outer_provider_identity: _item.outer_provider_identity
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование типа выплаты"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                css_class: "",
                is_deprecated: false,
                app_currency_id: 0,
                app_currency_title: "",
                outer_provider_identity: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание типа выплаты"]);
            });
        }
        this.doReSetRules();
    };
    CfgPayoutEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            css_class_rules: { isError: false },
            app_currency_rules: { isError: false },
            outer_provider_identity_rules: { isError: false }
        });
    };
    CfgPayoutEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                css_classname: this.state.css_class,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                app_currency_id: this.state.app_currency_id,
                outer_provider_identity: this.state.outer_provider_identity
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Тип выплаты изменен!");
            });
        }
    };
    CfgPayoutEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.css_class) || (this.state.css_class.length === 0)) {
            this.setState({ css_class_rules: { isError: true, errorMessage: "Поле [css класс] не заполнено!" } });
            return false;
        }
        if ((!this.state.outer_provider_identity) || (this.state.outer_provider_identity.length === 0)) {
            this.setState({ outer_provider_identity_rules: { isError: true, errorMessage: "Поле [внешний идентификатор провайдера] не заполнено!" } });
            return false;
        }
        if ((this.state.app_currency_id === 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Поле [валюта] имеет некорректное значение!" } });
            return false;
        }
        return true;
    };
    CfgPayoutEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                css_classname: this.state.css_class,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                app_currency_id: this.state.app_currency_id,
                outer_provider_identity: this.state.outer_provider_identity
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Тип выплаты добавлен!");
            });
        }
    };
    CfgPayoutEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CfgPayoutEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить тип выплаты";
        }
        else {
            return "Изменить тип выплаты";
        }
    };
    CfgPayoutEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 480 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название выплаты:", placeholder: "Введите название выплаты" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Css класс метки:", placeholder: "Введите css класс метки" }, value: this.state.css_class, onValueChanged: function (newVal) {
                    _this.setState({
                        css_class: newVal,
                        css_class_rules: { isError: false }
                    });
                }, required: true, rules: this.state.css_class_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Внешний ID провайдера:", placeholder: "Введите внешний идентификатор провайдера" }, value: this.state.outer_provider_identity, onValueChanged: function (newVal) {
                    _this.setState({
                        outer_provider_identity: newVal,
                        outer_provider_identity_rules: { isError: false }
                    });
                }, required: true, rules: this.state.outer_provider_identity_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, disabled: this.props.record != null, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Тип выплаты устарел", value: this.state.is_deprecated, onChecked: function (checked) {
                    _this.setState({
                        is_deprecated: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CfgPayoutEditor;
}(React.Component));
exports.default = CfgPayoutEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_payout/ui/component/CfgPayoutEditor.tsx
// module id = 2450
// module chunks = 0